import React from 'react';
import { PageHero } from '../components/PageHero';
import { ButtonLink } from '../components/ButtonLink';
import { PrincipleList } from '../components/PrincipleList';
import { MethodSteps } from '../components/MethodSteps';
import { CtaBand } from '../components/CtaBand';
import { employerCommitments, engagementModels } from '../data/employers';
export function Employers() {
  return <>
      <PageHero breadcrumb="For Employers" title="Leadership appointments, made with conviction." lead="We partner with boards, chief executives, and investors to find, assess, and secure leaders who will deliver your strategy." data-id="element-289" data-mp="hpnibiojk0ji">
        <ButtonLink to="/contact?type=employer" withArrow data-id="element-290" data-mp="8qjy2bdn1f3f">
          Discuss Your Hiring Needs
        </ButtonLink>
      </PageHero>

      <section className="bg-ivory" data-id="element-291" data-mp="2tfhhbdkqv35u">
        <div className="mx-auto max-w-site px-6 py-24 lg:px-10 lg:py-32" data-id="element-292" data-mp="2tgj2wbzdz81t">
          <h2 className="max-w-2xl font-serif text-4xl text-midnight-900 md:text-5xl" data-id="element-293" data-mp="2oetpipooyiak">What you can expect from us</h2>
          <div className="mt-12" data-id="element-294" data-mp="3elyezsdnas6n">
            <PrincipleList items={employerCommitments} columns={4} data-id="element-295" data-mp="3ejm1brex73ze" />
          </div>
        </div>
      </section>

      <section className="bg-champagne-50" data-id="element-296" data-mp="35l0kc0p3jx0q">
        <div className="mx-auto grid max-w-site gap-12 px-6 py-24 lg:grid-cols-12 lg:px-10 lg:py-32" data-id="element-297" data-mp="35jywswqw9i24">
          <div className="lg:col-span-4" data-id="element-298" data-mp="3aia5v59d7oja">
            <h2 className="font-serif text-4xl text-midnight-900 md:text-5xl" data-id="element-299" data-mp="2vuxjxffnbgsd">Ways to engage</h2>
            <p className="mt-5 text-[17px] leading-relaxed text-midnight-900/70" data-id="element-300" data-mp="30lnlehkyazhs">
              Each engagement is scoped to your situation, timeline, and the level of the role.
            </p>
          </div>
          <div className="lg:col-span-7 lg:col-start-6" data-id="element-301" data-mp="2qvkvwrd1g3o7">
            <PrincipleList items={engagementModels} data-id="element-302" data-mp="2qw43pf8z5boi" />
          </div>
        </div>
      </section>

      <section className="bg-midnight-950 text-champagne-50" data-id="element-303" data-mp="2cwuytbq7y3zu">
        <div className="mx-auto max-w-site px-6 py-24 lg:px-10 lg:py-32" data-id="element-304" data-mp="2hvfq2lnhtdc5">
          <h2 className="font-serif text-4xl md:text-5xl" data-id="element-305" data-mp="nepdukjeu3yb">How a search unfolds</h2>
          <div className="mt-14" data-id="element-306" data-mp="ngsfk1txdliv">
            <MethodSteps tone="dark" data-id="element-307" data-mp="inz8h7azi13m" />
          </div>
        </div>
      </section>

      <CtaBand title="Tell us about the leader you need." lead="A confidential, no-obligation conversation about your role, timing, and context." data-id="element-308" data-mp="emdzhx1km6yp" />
    </>;
}